<template>
  <AnalyticsBusinessLeads v-if="isDebug"/>
  <AnalyticsBusinessCompanyLeads v-else/>
</template>
<script>
import { isDebug } from "../../Utils/account";
import AnalyticsBusinessLeads from './Components/AnalyticsBusinessLeads';
import AnalyticsBusinessCompanyLeads from './Components/AnalyticsBusinessCompanyLeads';
export default {
  name: "AnalyticsBusiness",
  components: {AnalyticsBusinessLeads, AnalyticsBusinessCompanyLeads},
  data(){
    return {
      isDebug: isDebug()
    }
  }
};
</script>
